module.exports = __webpack_public_path__ + "static/media/elegir_x.afa5bfa1.svg";